import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import { closeConfirm, ConfirmButton, openConfirm, registerConfirmHandlers, openConnectDialog, closeConnectDialog, OtpDialogData, openOtpDialog, closeOtpDialog } from '../store/slices/confirmSlice';
import { ButtonAlignement } from '../components/ConfirmModal';
import {  PlebData } from '../models/Pleb';

interface OpenConfirmParamsButton extends ConfirmButton {
    onClick?: () => void;
}

// Type for the action payload
export interface OpenConfirmParams {
    title?: string | null;
    message?: string | null;
    buttons: OpenConfirmParamsButton[];
    buttonAlignement?: ButtonAlignement;
}

export function useConfirm() {
  const dispatch = useDispatch<AppDispatch>();
  const confirm = useSelector((state: RootState) => state.confirm);

  const formatData = (data: OpenConfirmParams) => {
    // Register handlers and get actionIds
    const actionIds = registerConfirmHandlers(data.buttons);

    // Dispatch with serializable data
    return {
        title: data?.title ?? null,
        message: data?.message ?? null,
        buttonAlignement: data?.buttonAlignement ?? ButtonAlignement.column,
        buttons: data.buttons.map((button, index) => {
            const { onClick, ...buttonWithoutOnClick } = button;
            return {
                ...buttonWithoutOnClick,
                actionId: actionIds[index]
            };
        })
    };
  };

  return {
    isOpen: confirm.isOpen,
    title: confirm.title,
    message: confirm.message,
    buttons: confirm.buttons,
    openConfirm: useCallback((data: OpenConfirmParams) => 
      dispatch(openConfirm(formatData(data))), [dispatch]),
    closeConfirm: useCallback(() => 
      dispatch(closeConfirm()), [dispatch]),
    connectDialogIsOpen: confirm.connectDialogIsOpen,
    connectDialogData: confirm.connectDialogData,
    openConnectDialog: useCallback((data: PlebData) => 
      dispatch(openConnectDialog(data)), [dispatch]),
    closeConnectDialog: useCallback(() => 
      dispatch(closeConnectDialog()), [dispatch]),
    otpDialogIsOpen: confirm.otpDialogIsOpen,
    otpDialogData: confirm.otpDialogData,
    openOtpDialog: useCallback((data: OtpDialogData) => 
      dispatch(openOtpDialog(data)), [dispatch]),
    closeOtpDialog: useCallback(() => 
      dispatch(closeOtpDialog()), [dispatch]),
  };
} 